import React from 'react'
import { getHotelCartItemPriceBreakdown } from '../../utils/agentCommissionCart'

const fmtAmount = (n) =>
  Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/**
 * Per-hotel cart line pricing.
 * showTaxes=false (default, cart/review): shows base + markup only, total excludes tax.
 * showTaxes=true (payment stage): shows full breakdown including tax & fees.
 */
const HotelCartItemPricing = ({ item, getPayable, showTaxes = false, className = '' }) => {
  const {
    currency,
    baseAmount,
    taxAndFees,
    markupAmount,
    totalPayable
  } = getHotelCartItemPriceBreakdown(item, getPayable)

  const displayTotal = showTaxes ? totalPayable : baseAmount + markupAmount

  return (
    <div className={`text-right space-y-1 min-w-[11rem] ${className}`}>
      <div className="flex justify-between items-center gap-4 text-[10px]">
        <span className="text-slate-400 font-bold uppercase tracking-wide">Base</span>
        <span className="text-slate-600 font-semibold tabular-nums">
          {currency} {fmtAmount(baseAmount)}
        </span>
      </div>
      {showTaxes && (
        <div className="flex justify-between items-center gap-4 text-[10px]">
          <span className="text-slate-400 font-bold uppercase tracking-wide">Tax &amp; fees</span>
          <span className="text-slate-600 font-semibold tabular-nums">
            {currency} {fmtAmount(taxAndFees)}
          </span>
        </div>
      )}
      {markupAmount > 0 && (
        <div className="flex justify-between items-center gap-4 text-[10px]">
          <span className="text-slate-400 font-bold uppercase tracking-wide">Markup</span>
          <span className="text-slate-600 font-semibold tabular-nums">
            {currency} {fmtAmount(markupAmount)}
          </span>
        </div>
      )}
      <div className="flex justify-between items-end gap-4 pt-1 border-t border-slate-100">
        <span className="text-[10px] font-black text-slate-900 uppercase tracking-widest">Total</span>
        <span className="text-xl typography-body font-black text-slate-900 tabular-nums">
          {currency} {fmtAmount(displayTotal)}
        </span>
      </div>
    </div>
  )
}

export default HotelCartItemPricing
